import {
    UserAccessLevelPresetServiceName,
    UserServiceName,
    UserValidationServiceName
} from "../utils/names/serviceNames";
import {UserService} from "./service/user.service";
import {UserServiceModuleConfiguration} from "./UserServiceModuleConfiguration";
import {UserValidationService} from "./service/user-validation.service";
import {UserAccessLevelPresetService} from "./service/user-access-level-preset.service";

UserServiceModuleConfiguration
    .createNewModule()
    .service(UserValidationServiceName, UserValidationService.instance)
    .service(UserServiceName, UserService.instance)
    .service(UserAccessLevelPresetServiceName, UserAccessLevelPresetService.instance)